import { Box, Button, Typography } from '@mui/material';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export const ErrorPage = (): ReactElement => (
  <Box
    height='60vh'
    display='flex'
    flexDirection='column'
    gap='3rem'
    justifyContent='center'
    alignItems='center'
    pt='20vh'
    gridArea='content'
  >
    <Typography variant='h3'>Something has gone wrong!</Typography>
    <img
      src='/burning-building.png'
      style={{ width: 'auto', height: '50%' }}
      alt='burning building'
    />
    <Typography variant='h3'>Please contact a Slabstack admin for support</Typography>
    <Link to='/' style={{ textDecoration: 'none', color: 'inherit' }}>
      <Button variant='slab-primary' onClick={(): void => {}}>
        Return home
      </Button>
    </Link>
  </Box>
);
